import { fromJS } from 'immutable';

import * as actionTypes from './actionTypes';

const initialState = fromJS({
  list: [],
});

export default (state = initialState, { type, data }) => {
  switch (type) {
    case actionTypes.FETCH_AIS_VERSION_LIST_SUCCESS:
      return state.set('list', fromJS(data));

    default:
      return state;
  }
};
